module.exports = __webpack_public_path__ + "img/logo-red-white-text.e3fd3f07.png";